import { trackingService } from "@/shared/services/tracking";

export const useTracking = () => {
  return {
    trackEvent: (eventName: string, properties?: Record<string, any>) => {
      return trackingService.trackEvent(eventName, properties);
    }
  };
};
